export default "__VITE_ASSET__B694awRM__"